import { Link, useLocation } from "react-router-dom"
import {
  SidebarMenuBadge,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import type { NavItem } from "../nav-types"

interface Props {
  item: NavItem
}

export function SidebarNavItem({ item }: Props) {
  const { pathname } = useLocation()
  const isActive =
    item.path === "/"
      ? pathname === "/"
      : pathname === item.path || pathname.startsWith(item.path + "/")

  const Icon = item.icon

  return (
    <SidebarMenuItem>
      <SidebarMenuButton asChild isActive={isActive} tooltip={item.label}>
        <Link to={item.path}>
          <Icon />
          <span>{item.label}</span>
        </Link>
      </SidebarMenuButton>
      {!item.enabled && (
        <SidebarMenuBadge className="text-[10px] uppercase tracking-wide text-muted-foreground">
          wkrótce
        </SidebarMenuBadge>
      )}
    </SidebarMenuItem>
  )
}
